<template>
  <div class="page-container">
    <!-- Bütün sayfayı kaplayan loading ekranı -->
    <div v-if="loading" class="loading-overlay">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
      <p>Yükleniyor...</p>
    </div>

    <div class="row" v-show="!loading">
      <div class="container">
        <vue-good-table
            ref="clientTable"
            :key="tableKey"
            mode="remote"
            @on-column-filter="onColumnFilter($event.columnFilters)"
            @on-page-change="onPageChange"
            @on-per-page-change="onPerPageChange"
            @on-sort-change="onSortChange"
            :rows="rows"
            :columns="columns"
            :totalRows="totalRecords"
            :line-numbers="true"
            :rowStyleClass="rowClass"
            :pagination-options="{
              enabled: true,
              perPage: serverParams.perPage,
              perPageDropdown: [5, 10, 20, 50],
              dropdownAllowAll: false,
              mode: 'records',
              nextLabel: 'Sonraki',
              prevLabel: 'Önceki',
              rowsPerPageLabel: 'Sayfa başına satır',
              ofLabel: '/',
              pageLabel: 'sayfa',
              allLabel: 'Tümü',
              initialPage: serverParams.page
            }"
        >
          <div slot="table-actions">
            <b-button
                type="submit"
                variant="primary"
                v-on:click.prevent="updateClients"
                :disabled="loading"
            >
              <b-spinner v-if="loading" small></b-spinner>
              <span v-else>İşletmeleri Güncelle</span>
            </b-button>
          </div>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'actions'">
              <div class="d-flex justify-content-center gap-2 px-2">
                <b-button
                    variant="success"
                    @click.prevent="updateRecord(props.formattedRow)"
                >
                  Güncelle
                </b-button>
                <b-button
                    variant="danger"
                    @click.prevent="deleteClients(props.formattedRow.id)"
                >
                  Sil
                </b-button>
              </div>
            </span>
            <!-- Yeni eklenen: İşletme Adı tıklanabilir -->
            <span v-else-if="props.column.field === 'name'">
              <a href="#" @click.prevent="goToTransactionHistory(props.row)">
                {{ props.formattedRow.name }}
              </a>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
import ClientService from '../../service/ClientService';

const LOCAL_STORAGE_KEY_ADMIN_CLIENT_LIST_FILTERS = 'adminClientListFilters';
const LOCAL_STORAGE_KEY_ADMIN_CLIENT_LIST_SCROLL = 'adminClientListScroll';
const SESSION_STORAGE_KEY_GOING_TO_UPDATE = 'goingToUpdate';

export default {
  name: 'client-filter-list',
  data() {
    return {
      totalRecords: 0,
      loading: false,  // ✅ Sayfa yükleniyor mu?
      columns: [
        {
          field: 'id',
          hidden: true
        },
        {
          label: 'İşletme Adı',
          field: 'name',
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'İşletme Adına Göre Filtrele',
            trigger: 'enter',
          }
        },
        {
          label: 'Kullanıcı Adı',
          field: 'username',
          sortable: false,
        },
        {
          label: 'Bakiye',
          field: 'balanceText',
          tdClass: 'text-right text-nowrap'
        },
        {
          field: 'balance',
          hidden: true
        },
        {
          field: 'balanceLimit',
          hidden: true
        },
        {
          field: 'actions',
          sortable: false,
        }
      ],
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: '',
        },
        page: 1,
        perPage: 10
      },
      rows: [],
      tableKey: 0,
    };
  },
  watch: {
    serverParams: {
      handler(newVal) {
        localStorage.setItem(
            LOCAL_STORAGE_KEY_ADMIN_CLIENT_LIST_FILTERS,
            JSON.stringify(newVal)
        );
      },
      deep: true
    }
  },
  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems(this.serverParams);
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.loadItems(this.serverParams);
    },

    onColumnFilter(params) {
      this.updateParams({ columnFilters: params, page: 1 });
      this.loadItems(this.serverParams);
    },

    onSortChange(params) {
      let sortField = undefined;
      if (params[0]?.field === 'balanceText') {
        sortField = 'balance';
      }
      const sort = {
        field: sortField || '',
        type: params[0]?.type || '', // 'asc' veya 'desc'
      };
      this.updateParams({ sort });
      this.loadItems(this.serverParams);
    },

    async loadItems(params) {
      this.loading = true;
      try {
        const response = await ClientService.list({
          ...params,
          sortField: params.sort.field,
          sortDirection: params.sort.type,
        });
        this.rows = response.data.map(item => ({
          ...item,
          name: item.shortName ? `${item.shortName} (${item.name})` : item.name
        }));
        this.totalRecords = response.total;
      } finally {
        this.loading = false;
      }
    },

    async updateClients() {
      this.loading = true;  // ✅ Sayfa yükleniyor
      try {
        await ClientService.fetch();
        await this.loadItems(this.serverParams);  // Güncellemeden sonra listeyi yenile
        this.$notification(this, "İşletmeler başarıyla güncellendi.");
      } catch (error) {
        console.error("İşletmeler güncellenirken hata oluştu:", error);
        this.$errorNotification(this, "İşletmeler güncellenirken hata oluştu.");
      } finally {
        this.loading = false; // ✅ İşlem bittiğinde kaldır
      }
    },

    async deleteClients(id) {
      this.loading = true;  // ✅ Sayfa yükleniyor
      try {
        await ClientService.deleteClient(id);
        await this.loadItems(this.serverParams);
        this.$notification(this, "İşletme başarıyla silindi.");
      } catch (error) {
        console.error("İşletme silinirken hata oluştu:", error);
        this.$errorNotification(this, "İşletme silinirken hata oluştu.");
      } finally {
        this.loading = false; // ✅ İşlem bittiğinde kaldır
      }
    },

    updateRecord(params) {
      sessionStorage.setItem(SESSION_STORAGE_KEY_GOING_TO_UPDATE, 'true');
      this.$router.push({ name: 'AdminShopUpdate', params : params });
    },

    goToTransactionHistory(row) {
      this.$router.push({
        name: 'AdminTransactionHistory',
        params: { id: row.id, name: row.name },
      });
    },

    rowClass(row) {
      if (row.balance > 0) {
        return 'row-positive';
      } else if (row.balance < 0) {
        return 'row-negative';
      } else {
        return ''; // sıfır için normal
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    const fromUpdate = sessionStorage.getItem(SESSION_STORAGE_KEY_GOING_TO_UPDATE) === 'true';

    if (fromUpdate) {
      localStorage.setItem(
          LOCAL_STORAGE_KEY_ADMIN_CLIENT_LIST_SCROLL,
          window.scrollY.toString()
      );

      localStorage.setItem(
          LOCAL_STORAGE_KEY_ADMIN_CLIENT_LIST_FILTERS,
          JSON.stringify(this.serverParams)
      );
    } else {
      localStorage.removeItem(LOCAL_STORAGE_KEY_ADMIN_CLIENT_LIST_SCROLL);
      localStorage.removeItem(LOCAL_STORAGE_KEY_ADMIN_CLIENT_LIST_FILTERS);
    }

    next();
  },
  async mounted() {
    const fromUpdate = sessionStorage.getItem(SESSION_STORAGE_KEY_GOING_TO_UPDATE) === 'true';

    if (fromUpdate) {
      const saved = localStorage.getItem(LOCAL_STORAGE_KEY_ADMIN_CLIENT_LIST_FILTERS);
      if (saved) {
        try {
          this.serverParams = JSON.parse(saved);

          // Vue-good-table yeniden render edilsin ki initialPage dikkate alınsın
          this.tableKey++;
        } catch (e) {
          console.warn('serverParams verisi bozuk:', e);
        }
      }
    }

    await this.loadItems(this.serverParams);

    if (fromUpdate) {
      this.$nextTick(() => {
        setTimeout(() => {
          const scroll = localStorage.getItem(LOCAL_STORAGE_KEY_ADMIN_CLIENT_LIST_SCROLL);
          if (scroll) {
            window.scrollTo(0, parseInt(scroll));
          }

          sessionStorage.removeItem(SESSION_STORAGE_KEY_GOING_TO_UPDATE);
        }, 100);
      });
    }
  }
};
</script>

<style>
/* Sayfanın üstüne loading efekti ekleyen CSS */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); /* Yarı saydam beyaz */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 1000;
  font-size: 20px;
}
.row-positive {
  background-color: #e6f9e6; /* açık yeşil */
}

.row-negative {
  background-color: #fde8e8; /* açık kırmızı */
}
.vgt-pagination {
  padding: 10px 0;
  font-size: 14px;
}

.vgt-pagination__info {
  margin-right: 10px;
}
</style>
